import { useRef } from "react";
import ModalPop from "./ModalPop";

const Event1 = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div className="bg-primary relative w-full h-full 3xl:px-[calc((100%-var(--container))/2)] mx-auto">
      <img
        onClick={openfunc}
        data-aos="fade-up"
        className="hidden lg:block"
        src="/images/eventPc.webp"
        alt="비우고 채우고 유품정리·특수청소 할인 이벤트 안내"
        loading="lazy"
      />
      <img
        onClick={openfunc}
        data-aos="fade-right"
        className="block lg:hidden px-[calc((100%-var(--container))/2)] mb-3"
        src="/images/eventM1.webp"
        alt="비우고 채우고 이벤트 안내"
        loading="lazy"
      />
      <img
        data-aos="fade-left"
        className="block lg:hidden"
        src="/images/eventM2.webp"
        alt="비우고 채우고 서비스 상세 안내"
        loading="lazy"
      />
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
    </div>
  );
};

export default Event1;
